{
  "title": "Choose an option to start the onboarding process",
  "card":{
  "individual":{
      "title": "Individual",
      "body": "Innovative ways to manage your personal finances"
  },
  "corporation":{
      "title": "Corporation",
      "body": "Let us help your company grow even further."
  }
  }
}